import MenuItem from 'material-ui/MenuItem';
import { RadioButtonGroup } from 'material-ui/RadioButton';
import SelectField from 'material-ui/SelectField';
import Toggle from 'material-ui/Toggle';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import * as actions from '../../actions/actions.jsx';
import s from '../../services/allservices.jsx';
import Loader from '../loader/loader.jsx';
import RaisedButton from 'material-ui/RaisedButton';
import CardInfo from '../dashboard/cardlist'
import Checkbox from '@material-ui/core/Checkbox'
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth.js'
import OtpPopup from '../otp/OtpPopup.js';
import { withRouter } from 'react-router-dom';
const styles = {
    
    block: {
        maxWidth: 250,
    },
    radioButton: {
        marginBottom: 16,
    },
    blockmargin: {
        marginBottom: 20
    },
    radioIcon: {
        fill: "#333"
    },
    toggle: {
        marginBottom: 16,
    },
    thumbSwitched: {
        backgroundColor: 'ff8925',
    },
    trackSwitched: {
        backgroundColor: '#ff8925',
    },
};

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    cardState: state.getCardReducer.cardState
})
const mapDispatchToProps = dispatch =>
({
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    }
})

const JSEncrypt = window.JSEncrypt
class SuspendCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardDetailsId: "",
            selectedCard: [],
            selectedNewCard: [],
            cardStatus: '',
            loader: true,
            cardAccount: 1,
            filteredCards: [],
            Toggled: false,
            checked: false,
            tokenConsent: true,
            otpOpen: false,
            otp: "",
            popupLoader: false,
        }
    }
    componentDidMount() {
        const { publicKey } = this.props
        const { cardState } = this.props

        let _this = this

        if (cardState && cardState.length !== 0) {

            var filteredR = cardState.body.filter((val) => {

                return (val.cardType)
            })

            let filteredCards = filteredR

            this.setState({
                loader: false,
                cardAccount: filteredCards[0].cardDetailsId,
                selectedCard: filteredCards[0],
                selectedNewCard: [filteredCards[0]],
                filteredCards: filteredCards,
                cardInUse: filteredCards[0],
            }, () => {

                _this.setState({
                    loader: true
                })
                if (this.state.selectedCard && (this.state.selectedCard.cardStatus === "Unlocked")) {
                    this.setState({
                        Toggled: false,
                        // cardStatus: 'L'
                    })
                } else {
                    this.setState({
                        Toggled: true,
                        // cardStatus: 'UL'
                    })
                }
            })

        }
        setTimeout(function () {
            if (publicKey && publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);


                const state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)
            }
        }, 500);


    }


    componentWillReceiveProps(nextProps) {

      
        this.setState({
            loader: true
        })
        try {
            if (nextProps.cardState && nextProps.cardState.length !== 0) {

                var filteredR = nextProps.cardState.body.filter((val) => {
                    return (val.cardType)
                })
                var filteredCards = filteredR

                this.setState({
                    loader: false,
                    cardAccount: filteredCards[0].cardDetailsId,
                    selectedCard: filteredCards[0],
                    selectedNewCard: [filteredCards[0]],
                    filteredCards: filteredCards,
                    cardInUse: filteredCards[0],
                }, () => {

                    if (this.state.selectedCard && (this.state.selectedCard.cardStatus === "Unlocked")) {
                        this.setState({
                            Toggled: false,
                            cardStatus: 'L'
                        })
                    } else {
                        this.setState({
                            Toggled: true,
                            cardStatus: 'UL'
                        })
                    }
                })
            }
        } catch (e) {

        }


    }
    onChange = (e) => this.setState({ [e.target.name]: e.target.value })

    handleChange2 = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    // for otp open
    otpPopupOpenModal = () => {

        this.setState({
            otpOpen: true,
            popupLoader: false,
        }, () => {

            this.handleRequestOtp();

        });

    };
    // for otp close
    otpPopupCloseModal = () => {
     this.refreshpage()
        this.setState({
            otpOpen: false,
        });
    };

    // OTP submit
    handleOtpSubmit = (otp, onSuccess, onError) => {

        this.setState({
            otp: otp,
            popupLoader: true,
        }, () => {

            this.handleBlock(onSuccess, onError);

        });

    };
    handleRequestOtp = () => {

        let token = "Token " + localStorage.getItem("token");

        const { publicKey } = this.props;

        const public_Key = publicKey.body.publickey;

        let encrypt = new JSEncrypt();
        encrypt.setPublicKey(public_Key);

        let state = {
            cardDetailsId: encrypt.encrypt(this.state.cardAccount),
            applicationId:
                localStorage.getItem('pform') === 'AU'
                    ? 'klickexau'
                    : 'klickex'
        };

        let plink =
            localStorage.getItem("pform") === "AU"
                ? process.env.REACT_APP_SERVICEURL_AU
                : process.env.REACT_APP_SERVICEURL_NZ;

        let gid = getClientId();
        let traceId = getClientId();

        fetch(plink + s.otp_block_card, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: token,
                clientId: gid,
                clientSecret: getClientSecret(gid, state.applicationId),
                "X-Trace-Id": traceId,
                "X-KlickEx-Client": buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then((response) => {
                let _this = this;
                if (
                    response.status === 200 ||
                    response.status === 201 ||
                    response.status === 204
                ) {

                    toast.success(response.headers.get("message"), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                    });

                } else if (response.status === 401) {

                    if (_this.props.history !== undefined) {
                        _this.props.history.push('/sessionout')
                    }

                } else {

                    toast.error(response.headers.get("message"), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                    });
                }
            });
    };
    handleBlock(onSuccess, onError) {
        this.setState({
            loader: true
        })
        const { publicKey } = this.props

        let _this = this;

        if (publicKey && publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);

            let state = {
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                cardDetailsId: encrypt.encrypt(this.state.cardAccount),
                cardStatus: encrypt.encrypt(this.state.cardStatus),
                // otp: this.state.otp,
                reason: this.state.cardStatus === "L" ? "Blocking Temporarily" : "Un Blocking Temporarily"
            }
            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ

            let traceId = getClientId();
            fetch(plink + s.block_card, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': "Token " + localStorage.getItem('token'),
                    'X-Trace-Id': traceId,
                    'X-KlickEx-Client': buildClientHeader(),

                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        // if (onSuccess) {
                        //     onSuccess();
                        // }

                        this.setState({
                            // popupLoader: false,
                            loader: true
                        }, () => {

                            setTimeout(() => {

                                this.setState({
                                    loader: false
                                });

                                window.location.reload(true);

                            }, 3000);

                        });


                        console.log("Action tokenConcent ", this.state.tokenConsent)
                        if (this.state.tokenConsent === true && this.state.cardStatus === 'L' && this.state.selectedCard.provisionToDigitalWallet === true) {
                            this.handleUpdateTokenbyKit()
                        }
                    }
                    else if (response.status === 204) {

                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        // if (onSuccess) {
                        //     onSuccess();
                        // }

                        this.setState({
                            // popupLoader: false,
                            loader: true
                        }, () => {

                            setTimeout(() => {

                                this.setState({
                                    loader: false
                                });

                                window.location.reload(true);

                            }, 500);

                        });
                        console.log("Action tokenConcent ", this.state.tokenConsent)
                        if (this.state.tokenConsent === true && this.state.cardStatus === 'L' && this.state.selectedCard.provisionToDigitalWallet === true) {
                            this.handleUpdateTokenbyKit()
                        }
                        // document.getElementById("blockModal").style.display = "none"
                        const state = {
                            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                            accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                        }
                        this.props.fetchCard(state)
                        this.setState({
                            loader: false
                        })

                    }
                    else if (response.status === 401) {

                        this.setState({
                            // popupLoader: false,
                            loader: false
                        });

                        if (this.props.history !== undefined) {
                            this.props.history.push('/sessionout')
                        }

                    }

                    else if (response.status === 422) {
 this.refreshpage()
                        this.setState({
                            // popupLoader: false,
                            loader: false,
                        });
                        // if (onError) {
                        //     onError(response.headers.get('message'));
                        // }
                        let message = response.headers.get("message");
 
                        // response.json().then((json) => {
                        // message = json.message
                        //     ? json.message
                        //     : response.headers.get("message");
                       
                        toast.error(message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60,
                        });
                        // });
 
                        // toast.error(message, {
                        //     position: "top-right",
                        //     autoClose: 3000,
                        //     hideProgressBar: false,
                        //     closeOnClick: true,
                        //     pauseOnHover: true,
                        //     draggable: true,
                        //     draggablePercent: 60,
                        // });
 
                    }
                    else {
                         this.refreshpage()

                        this.setState({
                            // popupLoader: false,
                            loader: false
                        }, () => {

                            // if (onError) {
                            //     onError(response.headers.get('message'));
                            // }

                        });
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                })

        }


    }




    handleSelect = (event, index, value) => {


        const { filteredCards } = this.state

        for (let i = 0; i < filteredCards.length; i++) {


            if (filteredCards[i].cardDetailsId === value) {
                this.setState({
                    cardInUse: filteredCards[i],
                    selectedCard: filteredCards[i],
                    selectedNewCard: [filteredCards[i]],
                })
            }
        }
        this.setState({ cardAccount: value }, () => {


            for (let i = 0; i < filteredCards.length; i++) {
                if (value === filteredCards[i].cardDetailsId) {


                    this.setState({

                        selectedCard: filteredCards[i]
                    }, () => {

                        if (this.state.selectedCard && (this.state.selectedCard.cardStatus === "Unlocked")) {

                            this.setState({
                                Toggled: false,
                                cardStatus: 'L'
                            })
                        } else {
                            this.setState({
                                Toggled: true,
                                cardStatus: 'UL'
                            })
                        }
                    })
                }
            }
        });

        // this.setState({ cardAccount: value }, () => {
        //     loader: true
        //     this.props.fetchTransferHistory(this.state.cardAccount, this.state.statementFromDate, this.state.statementTodDate, this.state.show)
        // });

    }

handleToggle() {
    const newToggled = !this.state.Toggled;
    const newCardStatus = newToggled ? "L" : "UL";

    this.setState({ Toggled: newToggled, cardStatus: newCardStatus }, () => {
        const modal = document.getElementById("blockModal");
        modal.style.display = "block";
        modal.classList.add("show");
        document.body.classList.add("modal-open");
    });
}


refreshpage() {
    const modal = document.getElementById("blockModal");
    modal.style.display = "none";
    modal.classList.remove("show");
    document.body.classList.remove("modal-open");

    // Revert toggle to real card status
    const isUnlocked = this.state.selectedCard && this.state.selectedCard.cardStatus === "Unlocked";
    this.setState({
        Toggled: !isUnlocked,   // Unlocked → false(off), Locked → true(on)
        cardStatus: isUnlocked ? "L" : "UL"
    });
}
    handleCheckbox = () => {
        this.setState({
            tokenConsent: !this.state.tokenConsent,
        })
    }
    handleUpdateTokenbyKit = () => {
        console.log("Action clicked")
        this.setState({
            loader: true
        })

        let state = {
            kitNo: this.state.selectedCard.kitNo,
            entityId: this.state.selectedCard.customerId,
            reason: 'Test Reason',
            kitUpdateType: 'LOCKED',
            operationType: 'UPDATE',
        }
        console.log("Update Token called", state)
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let traceId = getClientId();
        fetch(plink + s.updateTokensByKit, {
            method: "POST",
            headers: new Headers({
                Authorization: `Token ${localStorage.getItem("token")}`,
                'X-Trace-Id': traceId,
                //   Authorization : 'Token eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJDaGFybGllUkwiLCJhY2NvdW50SWQiOiIyMTJGQ0hBUkxJRSIsInJvbGUiOiJhZG1pbiIsImlzcyI6IiNAIUhlYWx0aDVDa21mIUAjIiwiZXhwIjoxNzUxNTMxOTAzLCJpYXQiOjE3NTE0NDU1MDN9.IHRg20byY1Y9ISKNdsTXH8ToVkzEVpGq9nnBjHqQNCJV80xAGjjE6RZvAHIouxxYsKJ0hrAn0gU-NjECsIln-g',
                "Content-Type": "application/json",
                'X-KlickEx-Client': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        }).then((response) => {
            if (response.status === 200) {
                response.json().then((json) => {
                    // toast.success(response.headers.get("message"), {
                    //   position: "top-right",
                    //   autoClose: 3000,
                    //   hideProgressBar: false,
                    //   closeOnClick: true,
                    //   pauseOnHover: true,
                    //   draggable: true,
                    //   draggablePercent: 60,
                    // });

                    this.setState({
                        loader: false,
                        reason: "",
                    })
                });
            } else if (response.status === 401) {
                toast.error(response.headers.get("message"), {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 60,
                });
                this.setState({
                    loader: false,
                })
            } else {
                toast.error(response.headers.get("message"), {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 60,
                });

                this.setState({
                    loader: false,
                    reason: "",
                })
            }
        });
    }
    render() {
        const { cardState } = this.props
        const { selectedCard, cardAccount } = this.state
        const { filteredCards } = this.state

        return (
            <div>
  <style>{`
            @keyframes otp-spin {
                to { transform: rotate(360deg); }
            }
        `}</style>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                    style={{ zIndex: 999999 }}
                />
                {this.state.otpOpen && (
                    <OtpPopup
                        open={this.state.otpOpen}
                        onClose={this.otpPopupCloseModal}
                        handleRequestOtp={this.handleRequestOtp}
                        onSubmit={this.handleOtpSubmit}
                    />
                )}

                {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 && filteredCards.length !== 0 ?
                    <div className="card-account ">
                        <div className="row">
                            <div className="col-md-4 pt-2" style={{ padding: "0px 15px" }}>

                                <div className="" >
                                    {filteredCards.length !== 0 &&
                                        <SelectField
                                            floatingLabelText=""
                                            onChange={this.handleSelect}
                                            className="input-width"
                                            name="Selected Card"
                                            autoComplete='none'
                                            style={{ marginTop: -12 }}
                                            value={cardAccount}>
                                            {filteredCards.map((value, i) =>
                                                <MenuItem className="menuitem" value={filteredCards[i].cardDetailsId} primaryText={filteredCards[i].cardNumber} key={i} />
                                            )}
                                        </SelectField>}
                                </div>

                                {/*<div className="summary-header">
                                    <div className="row">
                                        <div className="offset-md-8 col-md-4">
                                            <div className="row">
                                        <div className="col-sm-12 " > */}
                                {/*filteredCards.length !== 0 &&
                                                        <SelectField
                                                            floatingLabelText=""
                                                            onChange={this.handleSelect}
                                                            className="input-width"
                                                            name="Selected Card"
                                                            autoComplete='none'
                                                            style={{ marginTop: -12 }}
                                                            value={cardAccount}>
                                                            {filteredCards.map((value, i) =>
                                                                <MenuItem className="menuitem" value={filteredCards[i].cardDetailsId} primaryText={filteredCards[i].cardNumber} key={i} />
                                                            )}
                                                            </SelectField>*/}
                                {/* </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            <div className="col-sm-12">
                                <div className="row">
                                    <CardInfo
                                        selectedNewCard={this.state.selectedNewCard} />
                                </div>
                            </div>
                        </div>
                    </div>

                    : <Loader />
                }
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-12">
                            {/* <div className="block-card-header" style={styles.blockmargin}>
                                <h6>Lock / Unlock Card Options</h6>
                            </div> */}
                        </div>
                        <div className="col-sm-8 ml-1 p-0">
                            <div className="block-card-body">
                                {/* <Toggle
                                    label={selectedCard.cardStatus === 'Locked' ? 'Unlock My Card' : 'Lock My Card'}
                                    labelPosition="right"
                                    style={styles.toggle}
                                    thumbSwitchedStyle={styles.thumbSwitched}
                                    trackSwitchedStyle={styles.trackSwitched}
                                    defaultToggled={this.state.Toggled}
                                    onToggle={this.handleToggle.bind(this)}
                                    data-toggle="modal" data-target="#blockModal"
                                /> */}
 <Toggle
    label={selectedCard.cardStatus === 'Locked' ? 'Unlock My Card' : 'Lock My Card'}
    labelPosition="right"
    style={styles.toggle}
    thumbSwitchedStyle={styles.thumbSwitched}
    trackSwitchedStyle={styles.trackSwitched}
    defaultToggled={this.state.Toggled}
    onToggle={this.handleToggle.bind(this)}
/>
                                <RadioButtonGroup name="cardStatus" onChange={this.handleChange2.bind(this)}>
                                    {/* <RadioButton
                                        value="I"
                                        name="block"
                                        label="Block My Card (Temporarily Inactive)"
                                        style={styles.radioButton}
                                        iconStyle={styles.radioIcon}

                                    /> */}
                                    {/* <RadioButton
                                        value="mb"
                                        name="replace"
                                        label=" My card is damaged. Send me a replacement.   [$0.00]"
                                        style={styles.radioButton}
                                        iconStyle={styles.radioIcon}
                                       
                                    /> */}
                                    {/* <RadioButton
                                        value="R"
                                        name="newcard"
                                        label="My card is lost or stolen. Issue me a new card.   [$15.00]"
                                        style={styles.radioButton}
                                        iconStyle={styles.radioIcon}
                                        data-toggle="modal" data-target="#reissueModal"
                                       
                                    /> */}
                                </RadioButtonGroup>
                                {/* <RaisedButton
                                    label="Ok"
                                    className=""
                                    // style={styles.button}
                                    backgroundColor="#333"
                                    labelColor="#fff"
                                    data-toggle="modal"
                                    data-target="#blockModal"
                                    data-target="#reissueModal"
                              
                                /> */}
<div
    className="modal fade"
    id="blockModal"
    role="dialog"
    style={{
        display: "none",
        background: "rgba(0,0,0,0.45)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
    }}
>
    <div
        className="modal-dialog"
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            margin: "0 auto",
        }}
    >
        <div
            className="modal-content"
            style={{
                borderRadius: "20px",
                overflow: "hidden",
                position: "relative",
                width: "500px",
                maxWidth: "95%",
                minHeight: "280px",
                border: "none",
                boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
                background: "#fff",
            }}
        >

            
           {/* LOADER */}
{this.state.loader && (
    <div
        style={{
            position: "absolute",
            top: 0, left: 0,
            width: "100%", height: "100%",
            background: "rgba(255,255,255,0.9)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}
    >
        <div
            style={{
                width: 48,
                height: 48,
                borderRadius: "50%",
                border: "3px solid #e0e0e0",
                borderTopColor: "#378ADD",
                animation: "otp-spin 0.75s linear infinite",
            }}
        />
    </div>
)}

            {/* CONTENT */}
            {!this.state.loader && (
                <div>
                    <div
                        className="offset-sm-10 col-sm-2"
                        style={{
                            float: "right",
                            color: "rgb(119, 119, 119)",
                            position: "absolute",
                            right: "10px",
                            top: "5px",
                            zIndex: 99,
                        }}
                    >
                        <button
                            type="button"
                            style={{
                                fontSize: "32px",
                                background: "transparent",
                                border: "none",
                                outline: "none",
                            }}
                            onClick={this.refreshpage.bind(this)}
                            className="close"
                            data-dismiss="modal"
                        >
                            &times;
                        </button>
                    </div>

                    <div
                        className="modal-body text-center"
                        style={{
                            backgroundColor: "#fff",
                            padding: "45px 30px 40px",
                        }}
                    >

                        <div className="col-sm-12 mb-4">
                            <i
                                className={
                                    selectedCard.cardStatus === "Unlocked"
                                        ? "fa fa-lock fa-4x animated rotateIn"
                                        : "fa fa-unlock fa-4x animated rotateIn"
                                }
                                style={{
                                    color: "black",
                                }}
                            />
                        </div>

                        <div
                            className="col-sm-12 mb-4"
                            style={{
                                fontSize: "20px",
                                fontWeight: "500",
                                lineHeight: "32px",
                                color: "#333",
                            }}
                        >
                            <span>
                                Are you sure, you want to{" "}
                                {selectedCard.cardStatus === "Unlocked"
                                    ? "lock"
                                    : "unlock"}{" "}
                                the card?
                            </span>
                        </div>

                        {(this.state.cardStatus === "L" &&
                            this.state.selectedCard.provisionToDigitalWallet === true) && (
                                <div
                                    className="col-sm-12 pb-4"
                                    style={{
                                        minHeight: "70px",
                                        textAlign: "left",
                                        marginBottom: "15px",
                                    }}
                                >
                                    <div
                                        className="pull-left aligned-check"
                                        style={{
                                            width: "100%",
                                            marginLeft: "-20px",
                                            marginTop: "10px",
                                        }}
                                    >
                                        <Checkbox
                                            size="small"
                                            checked={this.state.tokenConsent}
                                            value={this.state.tokenConsent}
                                            onChange={this.handleCheckbox}
                                            name="tokenConsent"
                                            color="primary"
                                        />

                                        <span
                                            style={{
                                                marginTop: "10px",
                                                marginLeft:"20px",
                                                lineHeight: "45px",
                                            }}
                                        >
                                            Suspend tokens temporarily.
                                        </span>
                                    </div>

                                    <span
                                        className="m-0"
                                        style={{
                                            position: "absolute",
                                            top: "45px",
                                            left: "30px",
                                            fontSize: "12px",
                                            color: "red",
                                            width: "100%",
                                        }}
                                    >
                                        Note : Recommended if the device is lost or stolen
                                    </span>
                                </div>
                            )}

                        <div
                            className="col-sm-12"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "18px",
                                flexWrap: "wrap",
                                marginTop: "10px",
                            }}
                        >

                            <RaisedButton
                                label="OK"
                                disabled={this.state.disabled}
                                onClick={this.handleBlock.bind(this)}
                                className="btn-std"
                                backgroundColor="#F39A3E"
                                labelColor="#fff"
                                buttonStyle={{
                                    borderRadius: "4px",
                                    minWidth: "110px",
                                    height: "42px",
                                }}
                            />

                            <RaisedButton
                                label="CANCEL"
                                disabled={this.state.disabled}
                                onClick={this.refreshpage.bind(this)}
                                className="btn-std"
                                backgroundColor="#F39A3E"
                                labelColor="#fff"
                                buttonStyle={{
                                    borderRadius: "4px",
                                    minWidth: "120px",
                                    height: "42px",
                                }}
                            />

                        </div>

                    </div>
                </div>
            )}

        </div>
    </div>
</div>
                                <div className="modal fade" id="reissueModal" role="dialog">
                                    <div className="modal-dialog ">
                                        <div className="modal-content " style={{ marginTop: "150px", background: "rgb(214, 70, 84)" }}>
                                            <div className="modal-header" style={{ padding: "3px", borderBottom: "none", height: "45px" }}>
                                                <div className="col-sm-12" style={{ marginTop: "7px" }}>
                                                    <div className="row">
                                                        <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                                            <span>Re-issue Card</span>
                                                        </div>
                                                        <div className="offset-4 col-sm-2" style={{ float: "right", color: "rgb(119, 119, 119)" }}>
                                                            <button type="button" onClick={this.refreshpage.bind(this)} className="close" data-dismiss="modal">&times;</button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                                                <div className="col-sm-12" >
                                                    <i className="fa fa-question fa-4x mb-3 animated rotateIn" style={{ color: "rgb(214, 70, 84)" }}></i>
                                                </div>
                                                <div className="col-sm-12" style={{ fontSize: "20px" }}>
                                                    <span>Are you sure, you want to re-issue a new card? </span>
                                                </div>
                                                <div className="col-sm-12" >
                                                    <button type="button" className="btn btn-std" onClick={this.refreshpage.bind(this)} style={{ marginRight: "10px", backgroundColor: "#fff", fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(119, 119, 119)" }} data-dismiss="modal">Cancel</button>
                                                    <button type="button" className="btn btn-std" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)" }} onClick={this.handleBlock.bind(this)} data-dismiss="modal">Ok</button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>

            </div>

        )
    }
}
SuspendCard.defaultProps = {
    cardState: {
        status: 600
    }
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SuspendCard)
);


// WEBPACK FOOTER //
// ./src/components/additionalservices/suspendcard.jsx